import React , {Component} from 'react';
import {
    Toolbar,
    Link,
} from 'framework7-react';

class AppToolbar extends Component{
    render(){
        return(
            <div id="footer-tabs-container" className={this.props.show ? "show" : "dont-show"}>

                <div className="b-container p-0" >
                    <div className="b-row no-gutters justify-content-center">
                        <div className="b-col-md-6">
                            <Toolbar tabbar labels bottom id="footer-tabs">



                                <Link href="/"  tabLink="#profile">
                                    <img className="img off" src="https://www.narenj.me/webappassets/images/toolbar-profile-tab-off.svg" />
                                    <img className="img on" src="https://www.narenj.me/webappassets/images/toolbar-profile-tab-on.svg" />
                                    <div className="title">
                                        پروفایل
                                    </div>
                                </Link>

                                <Link href="/"  tabLink="#contact">
                                    <img className="img off" src="https://www.narenj.me/webappassets/images/toolbar-contact-tab-off.svg" />
                                    <img className="img on" src="https://www.narenj.me/webappassets/images/toolbar-contact-tab-on.svg" />
                                    <div className="title">
                                        تماس
                                    </div>
                                </Link>



                                <Link href="/orders-list/"  tabLink="#orders-list">
                                    <img className="img off" src="https://www.narenj.me/webappassets/images/toolbar-orders-tab-off.svg" />
                                    <img className="img on" src="https://www.narenj.me/webappassets/images/toolbar-orders-tab-on.svg" />
                                    <div className="title">
                                        پیشینه سفارشات
                                    </div>
                                </Link>



                                <Link href="/"  tabLink="#branch-list" tabLinkActive>
                                    <img className="img off" src="https://www.narenj.me/webappassets/images/toolbar-resturan-tab-off.svg" />
                                    <img className="img on" src="https://www.narenj.me/webappassets/images/toolbar-resturan-tab-on.svg" />
                                    <div className="title">
                                        رستوران ها
                                    </div>
                                </Link>

                            </Toolbar>
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}

export default AppToolbar;